import { Component, inject } from '@angular/core';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';

import { MessageService, MessageStatus } from 'services/message/message.service';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { MessageTimePipe } from '../pipes/message.time.pipe.pipe';
import { NgComponentOutlet } from '@angular/common';

@Component({
  selector: 'app-messages',
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.scss'],
  imports: [FaIconComponent, MessageTimePipe, NgComponentOutlet],
})
export class MessagesComponent {
  messageService = inject(MessageService);

  faTrash = faTrashAlt;
  MessageStatus = MessageStatus;

  clearMessages(): void {
    this.messageService.clear();
  }
}
